import Input from '@mui/joy/Input';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import Checkbox from '@mui/joy/Checkbox';
import FormControl from '@mui/joy/FormControl';
import FormHelperText from '@mui/joy/FormHelperText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiscord } from '@fortawesome/free-brands-svg-icons';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Cookies from 'js-cookie';
import axios from 'axios';

function CreateAccount() {
    const [user_id, setUserId] = useState('');
    const [fullName, setName] = useState('');
    const [reintegrated, setReintegrated] = useState(false);
    const [selectedRankValue, setSelectedValue] = useState("");
    const [discordId, setDiscordId] = useState('');
    const [username, setUsername] = useState('');
    const navigate = useNavigate(); 
  
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const discordId = urlParams.get('discordId');
        const username = urlParams.get('username');
        const cookieUserId = Cookies.get('userid');
        const cookieName = Cookies.get('username');
        const connected = Cookies.get('accountCreated');

        if (connected === 'true') {
            navigate('/mainPanel');
        } else {
            if (Cookies.get("email")) {
                if (cookieUserId && cookieName) {
                    setUserId(cookieUserId);
                    setName(cookieName);
                }
                if (discordId && username) {
                    setDiscordId(discordId);
                    setUsername(username);
                }
            } else {
                navigate('/');
            }
        }
    }, [navigate]);
      
  
    const handleDiscordConnect = () => {
      window.location.href = 'http://panelmedici.fplayt.ro:5000/login/discord';
    };

    const handleUserIdChange = (event: any) => {
        setUserId(event.target.value);
        Cookies.set('userid', event.target.value, { expires: 1 });
    }

    const handleNameChange = (event: any) => {
        setName(event.target.value);
        Cookies.set('username', event.target.value, { expires: 1 });
    }

    const handleChange = (event: React.MouseEvent | React.KeyboardEvent | React.FocusEvent | null, value: string | null) => {
      setSelectedValue(value || ""); 
    };

    const [canClick, setCanClick] = useState(true);
    const saveDataToDB = async () => {
        if (canClick === true) {
            setCanClick(false);
        } else {
            return;
        }
        if (!user_id || !fullName || !selectedRankValue || !discordId) {
            toast.error("Trebuie sa completezi toate campurile!")
            return;
        }
        try {
            toast.info("Ti se creeaza contul! Acest proces poate dura cateva secunde.")
            let token = Cookies.get("accessToken")
            const response = await axios.post('http://panelmedici.fplayt.ro:5000/api/create-profile', {
                user_id: user_id, 
                fullName: fullName, 
                selectedRankValue: selectedRankValue, 
                reintegrated: reintegrated, 
                discordId: discordId, 
                email: Cookies.get("email")
            }, { headers: { Authorization: `Bearer ${token}` } });
            if (response.statusText === "OK") {
                Cookies.set('accountCreated', "true");
                Cookies.set('myDiscordID', discordId);
                navigate("/mainPanel/")
                setCanClick(true);
            }
        } catch (error) {
            toast.error("A aparut o eroare! Profilul nu a fost creat.")
            console.error('Error updating member:', error);
        }
    }

    return (
        <div className="w-full h-full flex flex-col items-center justify-center">
            <span className="text-white textBold text-[3vw] text-[#323232] dark:text-white">CREEAZA PROFIL</span>
            <div className="w-[35%] h-[75%] flex flex-col items-center justify-center gap-[5%] mt-[1%] bg-black/20 rounded-lg shadow-lg shadow-black/10 backdrop-blur-sm border border-black/30 p-4">
                <div className="w-full h-[12%] flex flex-col justify-center items-center gap-[1%]">
                    <Input
                        defaultValue={Cookies.get("userid")}
                        onChange={handleUserIdChange}
                        color="neutral"
                        disabled={false}
                        placeholder="ID (/stats)"
                        size="md"
                        variant="outlined"
                        sx={{
                            backgroundColor: "#272727",
                            color: "white",
                            borderColor: "grey",
                            outlineColor: 'orange',
                            height: "100%",
                            width: "75%"
                        }}
                    />
                </div>
                <div className="w-full h-[12%] flex flex-col justify-center items-center gap-[1%]">
                    <Input
                        defaultValue={Cookies.get("username")}
                        onChange={handleNameChange}
                        color="neutral"
                        disabled={false}
                        placeholder="Nume Complet"
                        size="md"
                        variant="outlined"
                        sx={{
                            backgroundColor: "#272727",
                            color: "white",
                            borderColor: "grey",
                            outlineColor: 'orange',
                            height: "100%",
                            width: "75%"
                        }}
                    />
                </div>
                <div className="w-full h-[12%] flex flex-col justify-center items-center gap-[1%]">
                    <Select
                        placeholder="Grad"
                        size="md"
                        variant="outlined"
                        onChange={handleChange}
                        sx={{
                            backgroundColor: "#272727",
                            color: "white",
                            borderColor: "grey",
                            outlineColor: "orange",
                            height: "100%",
                            width: "75%",
                            ":hover": {
                            backgroundColor: "#353535",
                            },
                        }}
                    >
                        <Option value="Asistent-Medical">ASISTENT MEDICAL</Option>
                        <Option value="Medic-Stagiar">MEDIC STAGIAR</Option>
                        <Option value="Medic-Rezident">MEDIC REZIDENT</Option>
                        <Option value="Medic-Specialist">MEDIC SPECIALIST</Option>
                    </Select>
                </div>
                <div className="w-full h-[20%] flex flex-col justify-center items-center gap-[1%]">
                    <FormControl sx={{width: "75%"}}>
                        <Checkbox onClick={() => setReintegrated(!reintegrated)} sx={{color: "white"}} color="success" label="REINTEGRARE" />
                        <FormHelperText sx={{color: "grey"}}>Bifeaza casuta daca ai intrat prin REINTEGRARE</FormHelperText>
                    </FormControl>
                </div>
                    {discordId ? (
                        <div className="w-full h-[7%] flex flex-col justify-center items-center gap-[1%]">
                            <div className="w-full h-full flex items-center justify-center">
                                <span className="text-white textMedium text-[1.1vw] w-[75%] text-center text-wrap">Discord conectat! Username: {username}</span>
                            </div>
                        </div>
                    ) : (
                        <div className="w-full h-[20%] flex flex-col justify-center items-center gap-[1%]">
                            <div onClick={handleDiscordConnect} className="cursor-pointer w-[75%] h-[70%] gap-[2%] bg-blue-300 rounded-[.5vw] flex flex-row items-center justify-center bg-gradient-to-r from-[#0F5FD8] to-[#183DF5] cursor-pointer">
                                <FontAwesomeIcon className="text-white textBold text-[1.4vw]" icon={faDiscord} />
                                <span className="text-white textBold text-[1.4vw]">DISCORD CONNECT</span>
                            </div>
                        </div>
                    )}
                <div className="w-full h-[20%] flex flex-col justify-center items-center gap-[1%]">
                    <div onClick={saveDataToDB} className="cursor-pointer h-[80%] px-[14%] rounded-[0.4vw] flex items-center justify-center bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                        <span className="textExtraBold text-white text-[1.7vw]">VALIDEAZA DATELE</span>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}

export default CreateAccount;